import { NotificationArgsProps } from 'antd'
import { notification } from 'shared/ui'

export enum NOTIFICATION_TYPES {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  INFO = 'info',
}

export interface INotification {
  message: string
  title?: string
  type: NOTIFICATION_TYPES
  callback?: () => void
  key?: string
}

export const showNotification = (data: INotification) => {
  notification.config({
    placement: 'bottomRight',
  })

  if (data.key) {
    notification.destroy(data.key)
  }

  const config: NotificationArgsProps = {
    message: data.title,
    description: data.message
  }

  if (data.callback) {
    config.onClick = data.callback
  }

  if (data.type === NOTIFICATION_TYPES.SUCCESS) {
    notification.success(config)
  } else if (data.type === NOTIFICATION_TYPES.WARNING) {
    notification.warning(config)
  } else if (data.type === NOTIFICATION_TYPES.ERROR) {
    notification.error(config)
  }
}
